module.exports = __webpack_public_path__ + "img/landing page.7f31752b.png";